module.exports = __webpack_public_path__ + "img/2.d353a506.jpg";